function Header() {
  return (
    <h1 id="mbta-header">MBTA Subway Rail Tracker</h1>
  );
}

export default Header;
